export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative pt-28 pb-10 border-t border-[var(--border-faint)]"
      style={{ background: "var(--bg-deep)" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-20">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <div
                className="flex-shrink-0 px-1.5 py-1"
                style={{
                  background: "var(--logo-bg)",
                  backdropFilter: "blur(14px) saturate(140%)",
                  WebkitBackdropFilter: "blur(14px) saturate(140%)",
                }}
              >
                <img
                  src="/sovereign-logo.png"
                  alt="Sovereign Supercomputing"
                  className="h-10 md:h-12 w-auto pointer-events-none block"
                  style={{ mixBlendMode: "var(--logo-blend)" }}
                />
              </div>
              <div className="leading-tight">
                <div className="font-display text-[var(--text)] text-[15px] font-semibold tracking-tight">
                  SOVEREIGN
                </div>
                <div className="font-mono text-[9px] tracking-[0.3em] text-[var(--color-accent-text)]">
                  SUPERCOMPUTING
                </div>
              </div>
            </div>
            <p className="text-[var(--text-55)] text-sm leading-relaxed max-w-sm">
              Creating Australia&apos;s sovereign digital future through
              zero-carbon supercomputing infrastructure and regional
              technology leadership.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-[var(--text-40)] mb-5">
              Operations
            </div>
            <ul className="space-y-3 text-sm text-[var(--text-70)]">
              <li>Canberra, ACT</li>
              <li>Australia</li>
              <li>
                <a
                  data-testid="footer-email"
                  href="mailto:operations@sovereignhpc.com.au"
                  className="hover:text-[var(--color-yellow-deep)] dark:hover:text-[var(--color-yellow)] transition-colors"
                >
                  operations@sovereignhpc.com.au
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-[var(--text-40)] mb-5">
              Initiative
            </div>
            <ul className="space-y-3 text-sm text-[var(--text-70)]">
              <li>Sovereign Cloud</li>
              <li>Zero-Carbon</li>
              <li>Indo-Pacific</li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-[var(--text-40)] mb-5">
              Status
            </div>
            <div className="flex items-center gap-2 text-sm text-[var(--text-70)]">
              <span className="w-2 h-2 bg-[var(--color-yellow)] animate-pulse" />
              All systems · In Progress
            </div>
            <div className="font-mono text-[11px] text-[var(--text-40)] mt-3">
              v0.2 · Light/Dark
            </div>
          </div>
        </div>

        {/* Massive brand text */}
        <div
          aria-hidden
          className="font-display text-[15vw] leading-[0.85] tracking-[-0.04em] text-transparent select-none mb-12"
          style={{
            WebkitTextStroke: "1px var(--footer-stroke)",
          }}
        >
          SOVEREIGN.
        </div>

        <div className="flex flex-col md:flex-row justify-between gap-4 pt-8 border-t border-[var(--border-faint)] text-xs text-[var(--text-40)] font-mono tracking-wider">
          <div>© {year} Sovereign Supercomputing — Indo-Pacific Initiative</div>
          <div>Made in AU · Powered by 100% renewable energy</div>
        </div>
      </div>
    </footer>
  );
}
